import BaseModel from "./../base/baseModel";
import EspeciePagamento from "./../enum/especiePagamento";

export default class FormaPagamentoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    ativo = false;
    especie: EspeciePagamento = null;
}
